import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Table, Form, Input, Switch, Button, Popconfirm } from "antd";
import { SearchOutlined, InboxOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment";

const scrolElem = { x: 1430 };

const BulkFileMappingTable = (props) => {
  const {
    dataSource,
    updatedRecord,
    editingKey,
    setStateVals,
    submitRecord,
    deleteReport,
    editableCell
  } = props;

  const [searchedColumn, setSearchedColumn] = useState();
  const [searchText, setSearchText] = useState();
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex && text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  const isEditing = (record) => {
    return record._id == editingKey;
  };

  const edit = (record) => {
    setStateVals({
      updatedRecord: { ...record },
      editingKey: record._id,
    });
    // this.setState({selectedRecord:{...record},editingKey:record._id});
  };

  const cancel = () => {
    setStateVals({
      updatedRecord: {
        _id: undefined,
        bulk_source_file_name: "",
        status: false,
      },
      editingKey: null,
    });
    // this.setState({
    //   editingKey:null,
    //   selectedRecord:this.getDefaultRecord(),
    //   validate:undefined
    // },()=>console.log(this.state))
  };

  const columns = [
    {
      title: "Bulk Source File Name",
      dataIndex: "bulk_source_file_name",
      key: "bulk_source_file_name",
      width: "250px",
      ...getColumnSearchProps("bulk_source_file_name"),
      sorter: (a, b) =>
        a.bulk_source_file_name.localeCompare(b.bulk_source_file_name),
      editable: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "200px",
      render: (idx, record) => <span>{record.status ? "true" : "false"}</span>,
      sorter: (a, b) =>
        (a.status ? "true" : "false").localeCompare(
          b.status ? "true" : "false",
        ),
      editable: true,
    },
    {
      title: "Created by",
      dataIndex: "create_by",
      key: "create_by",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.create_by !== undefined && record.create_by.name
            ? record.create_by.name
            : ""}
        </span>
      ),
      editable: false,
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.create_at
            ? moment(record.create_at).local().format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </span>
      ),
      editable: false,
    },
    {
      title: "Updated by",
      dataIndex: "update_by",
      key: "update_by",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.update_by !== undefined && record.update_by.name
            ? record.update_by.name
            : ""}
        </span>
      ),
      editable: false,
    },
    {
      title: "Updated at",
      dataIndex: "update_at",
      key: "update_at",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.update_at
            ? moment(record.update_at).local().format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </span>
      ),
      editable: false,
    },
    {
      title: "Operation",
      dataIndex: "operation",
      fixed: "right",
      width: "180px",
      render: (idx, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <a
              onClick={() => {
                submitRecord();
              }}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </a>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a
                style={{
                  marginRight: 8,
                }}
              >
                Cancel
              </a>
            </Popconfirm>
            {/**<Popconfirm title="Sure to delete?" onConfirm={deleteReport}>
                    <a>Delete</a>
                  </Popconfirm>**/}
          </span>
        ) : (
          <a disabled={editingKey !== null} onClick={() => edit(record)}>
            Edit
          </a>
        );
      },
    },
  ].map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const compvar = {
    body: {
      cell: editableCell,
    },
  };
  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      className={"sm-custom-column-header"}
      scroll={scrolElem}
      components={compvar}
      rowKey="_id"
    />
  );
};

BulkFileMappingTable.propTypes = {};

export default BulkFileMappingTable;
